module.exports = __webpack_public_path__ + "img/9788959526840.34ec151c.jpg";